var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainDiv"},[_c('img',{staticClass:"imgMobile",attrs:{"src":_vm.srcUrl,"alt":""}}),_c('div',{staticClass:"textMobile"},[_vm._v(_vm._s(_vm.err)+"~")])])}
var staticRenderFns = []

export { render, staticRenderFns }